/**
 * OpenStreetMap raster tiles. No API key required.
 *
 * NOTE: tile.openstreetmap.org is fine for local development but has a usage
 * policy that forbids heavy/production traffic — swap in a proper tile provider
 * (MapTiler, Stadia, self-hosted, …) before shipping.
 */
export const OSM_STREET_STYLE = {
    version: 8,
    name: "OSM Street",
    sources: {
        osm: {
            type: "raster",
            tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
            tileSize: 256,
            attribution: "© OpenStreetMap contributors",
        },
    },
    layers: [{ id: "osm", type: "raster", source: "osm" }],
};
/**
 * Esri World Imagery satellite tiles. No API key required.
 */
export const OSM_SATELLITE_STYLE = {
    version: 8,
    name: "Satellite",
    sources: {
        satellite: {
            type: "raster",
            tiles: ["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],
            tileSize: 256,
            attribution: "© Esri, Maxar, Earthstar Geographics",
        },
    },
    layers: [{ id: "satellite", type: "raster", source: "satellite" }],
};
